import { Box, Stack, Typography } from '@mui/material';
import ButtonLink from 'components/ButtonLink/ButtonLink';
import { grays, primaryColors } from 'config/defaultTheme';
import { useTranslation } from 'react-i18next';

const footerLinkMapping = [
  {
    id: 'footer-link-1',
    ariaLabel: 'Privacy Policy',
    label: 'footer.privacyPolicy',
    address: 'https://www.wiley.com/privacy',
  },
  {
    id: 'footer-link-2',
    ariaLabel: 'Terms of Use',
    label: 'footer.termsOfUse',
    address: 'https://www.wiley.com/terms-of-use',
  },
  {
    id: 'footer-link-3',
    ariaLabel: 'Cookie Policy',
    label: 'footer.cookiePolicy',
    address: 'https://www.wiley.com/privacy/cookies',
  },
];

export function AdminFooter() {
  const { t } = useTranslation('admin');

  const openLink = (link: string) => {
    window.open(link, '_blank');
  };

  return (
    <Box>
      <Stack direction="row" justifyContent="center" spacing={2} padding={2}>
        {footerLinkMapping.map((link) => (
          <ButtonLink
            children={t(link.label)}
            key={link.id}
            aria-label={link.ariaLabel}
            sx={{ textTransform: 'none', fontSize: '0.875rem' }}
            onClick={() => openLink(link.address)}
          />
        ))}
      </Stack>

      <Box
        sx={{ backgroundColor: primaryColors.midnight }}
        padding={2} display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Typography variant="body1" color={grays.white}>
          {t('footer.copyright')}
        </Typography>
      </Box>
    </Box>
  );
}
